var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowForwardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_ios_FILL0_wght300_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1233 8.99998L5.4738 3.35046C5.32477 3.20142 5.25217 3.02402 5.256 2.81826C5.25985 2.61248 5.3363 2.43508 5.48533 2.28606C5.63437 2.13702 5.81177 2.0625 6.01753 2.0625C6.2233 2.0625 6.4007 2.13702 6.54974 2.28606L12.2916 8.03942C12.4271 8.17499 12.5276 8.32691 12.593 8.49518C12.6584 8.66345 12.6911 8.83172 12.6911 8.99998C12.6911 9.16824 12.6584 9.33651 12.593 9.50479C12.5276 9.67305 12.4271 9.82497 12.2916 9.96054L6.5382 15.7139C6.38917 15.8629 6.21368 15.9355 6.01176 15.9317C5.80985 15.9279 5.63437 15.8514 5.48533 15.7024C5.3363 15.5533 5.26178 15.3759 5.26178 15.1702C5.26178 14.9644 5.3363 14.787 5.48533 14.638L11.1233 8.99998Z",
    fill: "#333236"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardBlack);
export default __webpack_public_path__ + "static/media/arrow-forward-black.0431785a6006d85b99a2c0adf57ce2b5.svg";
export { ForwardRef as ReactComponent };